export default "__VITE_ASSET__Ch0YCA_1__"